import React from 'react';
import {
  Devices as DevicesIcon,
  SimCard as SimCardIcon,
  Build as MaintenanceIcon,
  FlashOn as QuickAssignIcon,
  BatchPrediction as BulkIcon,
} from '@mui/icons-material';
import TabHub from '../../components/layout/TabHub';
import DevicesPage from '../devices/DevicesPage';
import SimCardsPage from '../simcards/SimCardsPage';
import DeviceRevisionsPage from '../devices/revisions/DeviceRevisionsPage';
import QuickAssign from '../assistant/QuickAssign';
import BulkOperationsPage from '../bulk/BulkOperationsPage';

// Hub de Inventario: dispositivos GPS, SIMs, mantenimientos y herramientas de asignación.
const InventarioHub: React.FC = () => (
  <TabHub
    tabs={[
      { key: 'dispositivos', label: 'Dispositivos GPS', icon: <DevicesIcon />, element: <DevicesPage /> },
      { key: 'simcards', label: 'SIM Cards', icon: <SimCardIcon />, element: <SimCardsPage /> },
      { key: 'mantenimientos', label: 'Mantenimientos', icon: <MaintenanceIcon />, element: <DeviceRevisionsPage /> },
      { key: 'asignacion', label: 'Asignación Rápida', icon: <QuickAssignIcon />, element: <QuickAssign /> },
      { key: 'lote', label: 'Operaciones en Lote', icon: <BulkIcon />, element: <BulkOperationsPage /> },
    ]}
  />
);

export default InventarioHub;
